<ng-template #feedback_modal>
  <div id="feedback-modal">
    <div class="modal-header feedback-modal-header">
      <h5 class="modal-title">{{ feedBackData.questionGroup[0].question.title | translate }}</h5>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-12 d-flex justify-content-center">
          <h6 class="scw-header">{{ feedBackData.questionGroup[0].question.questionText | translate }}</h6>
        </div>
        <div class="col-12">
          <div class="star-rating-container star-rating-animation">
            <div
              (click)="selectStar(star.value)"
              (mouseenter)="setHovered(star.value)"
              (mouseleave)="setHovered(null)"
              *ngFor="let star of stars; let i = index"
              [ngClass]="!selectedRating || star.value > selectedRating ? ratingStarClass : ratingStarHoverClass"
            >
              <mat-icon>star</mat-icon>
              <span
                class="star-hint"
                *ngIf="
                  (selectedRating === null && hoveredRating === null && (i === 0 || i === stars.length - 1)) ||
                  (hoveredRating !== null && hoveredRating === star.value) ||
                  (selectedRating !== null && hoveredRating === null && selectedRating === star.value)
                "
              >
                {{ star.hint | translate }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-12 mt-1">
          <scw-mat-textarea
            class="feedback-textarea"
            [rows]="6"
            [block]="true"
            [rules]="[{ maxLength: 65535 }]"
            [placeholder]="textPlaceholder"
            [(inputModel)]="feedbackText"
          ></scw-mat-textarea>
        </div>
        <div class="col-12 privacy-text mt-1">
          <span>
            <a href="https://scw.ai/wp-content/uploads/2025/04/Privacy-Notice.pdf" target="_blank">
              {{ 'feedback.privacy.link' | translate }} <i class="fas fa-external-link-alt"></i>
            </a>
            {{ 'feedback.privacy.statement' | translate }}
          </span>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div class="buttons-left">
        <scw-mat-button
          (onClick)="dismissModal()"
          type="standard"
          [size]="genericHelperService.windowWidth <= 1024 ? 'sm' : 'md'"
        >
          {{ 'general.cancel' | translate }}
        </scw-mat-button>
      </div>
      <div class="buttons-right">
        <scw-mat-button
          (onClick)="submitFeedback()"
          [disabled]="selectedRating === null"
          [size]="genericHelperService.windowWidth <= 1024 ? 'sm' : 'md'"
        >
          {{ 'general.submit' | translate }}
        </scw-mat-button>
      </div>
    </div>
  </div>
</ng-template>
